module.exports = __webpack_public_path__ + "static/media/exit.f89e5f6f.svg";